import React from "react";
import PropTypes from "prop-types";
import { Button } from "config/initializers/styles.app";
import { hashHistory } from "react-router";
import { Loading } from "mobile/appComponents/loading/Loading.react";
import { getAppConfig } from "config/client.config";

export default class ErrorPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showErrorPage: false,
        };
    }

    static propTypes = {
        msg: PropTypes.string,
    };

    static defaultProps = {
        msg: getAppConfig().error.message,
    };

    componentDidMount() {
        setTimeout(() => {
            this.setState({ showErrorPage: true });
        }, 2000);
    }

    goBack = () => {
        if (getAppConfig().error.backLink.indexOf("http") === -1) {
            hashHistory.push(getAppConfig().error.backLink);
        } else {
            window.location = getAppConfig().error.backLink;
        }
    };

    render() {
        let isPortrait = window.innerHeight > window.innerWidth;

        let pageStyle = {
            width: this.props.fullPage ? "100vw" : "100%",
            height: "100vh",
            position: this.props.fullPage ? "fixed" : "relative",
            top: 0,
            left: 0,
            textAlign: "center",
            background: this.props.fullPage ? "#f5f5f5" : "transparent",
        };

        let errorImgStyle = {
            width: isPortrait ? "80%" : "30%",
            marginTop: isPortrait ? "20px" : "40px",
        };

        let errorMsgStyle = {
            width: isPortrait ? "80%" : "30%",
            margin: "0 auto 40px",
            fontSize: "2.5em",
            lineHeight: "1.2",
        };

        if (this.state.showErrorPage)
            return (
                <div style={pageStyle}>
                    <img
                        src={
                            getAppConfig().error.image === ""
                                ? "/assets/images/defaults/error.png"
                                : getAppConfig().error.image
                        }
                        alt="Error Time"
                        style={errorImgStyle}
                    />
                    <div style={errorMsgStyle}>{this.props.msg}</div>
                    <Button
                        color="red"
                        size="massive"
                        onClick={this.goBack}
                        style={{ margin: "0 auto", fontSize: isPortrait ? "1em" : "1.2em" }}
                    >
                        {getAppConfig().error.button}
                    </Button>
                </div>
            );
        else return <Loading />;
    }
}
